<!-- 头部 -->
<template>
  <div ref="fixHeard" class="fix_heard">
    <div class="navcontainer">
      <div class="Logo">
        <div class="icon">
          <router-link :to="{ path: '/home' }">
            <img src="../../../static/img/infoLogo.png" alt="" />
          </router-link>
        </div>
        <div class="tabs">
          <template v-for="(item, inx) in tabsList">
            <div class="item" :key="inx">
              <p
                class="tabs_item"
                @click="handleItem(item)"
                @mouseover="mouseenter(item)"
              >
                {{ item.name }}
              </p>
            </div>
          </template>
        </div>
        <div class="top_left">
          <i @click="drawer = true" class="iconfont icon-appstore"></i>
        </div>
      </div>
      <div class="call">
        <div class="icon_calls" style="margin-right: 10px">
          <img src="../../../static/img/phone.png" alt="" />
        </div>
        <div class="text">
          <p>+86 21 61871158</p>
        </div>
      </div>
    </div>
    <div class="item_navcon" v-if="hoverId === 2" @mouseleave="mouseleave()">
      <!--  -->
      <div class="show_box">
        <div class="show_item">
          <div class="icon">
            <i class="iconfont icon-dianshi"></i>
          </div>
          <div class="text">
            <div class="title">数字电视</div>
            <router-link :to="{ path: '/productChip' }">
              <p>直播卫星ABS—S系统解决方案</p>
            </router-link>
            <router-link :to="{ path: '/productChip1' }">
              <p>国标DTMB地面数字电视解决方案</p>
            </router-link>
          </div>
        </div>
        <div class="show_item">
          <div class="icon">
            <i class="iconfont icon-shop"></i>
          </div>
          <div class="text">
            <div class="title">智慧零售</div>
            <router-link :to="{ path: '/resale' }">
              <p>智慧零售系统解决方案</p>
            </router-link>
          </div>
        </div>
        <div class="show_item">
          <div class="icon">
            <i class="iconfont icon-xuexi"></i>
          </div>
          <div class="text">
            <div class="title">智慧学习</div>
            <router-link :to="{ path: '/study' }">
              <p>企业学习系统解决方案</p>
            </router-link>
          </div>
        </div>
        <div class="show_item">
          <div class="icon">
            <i class="iconfont icon-lianjiedian-connection-points"></i>
          </div>
          <div class="text">
            <div class="title">行业方案</div>
            <div class="text_box" style="display: flex">
              <div class="left" style="margin-right: 20px">
                <p>智慧园区</p>
                <p>智慧环保</p>
                <p>智慧工地</p>
              </div>
              <div class="right">
                <p>智慧社区</p>
                <p>智慧照明</p>
                <p>智慧党建</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item_navcon" v-if="hoverId === 5" @mouseleave="mouseleave()">
      <div class="show_box">
        <div class="show_item item1">
          <div class="box" @click="goDetail(1)">
            <div class="icon">
              <i class="iconfont icon-qiyexinxi"></i>
            </div>
            <div class="name">企业简介</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="show_item item1">
          <div class="box" @click="goDetail(2)">
            <div class="icon">
              <i class="iconfont icon-timeAxis"></i>
            </div>
            <div class="name">发展历程</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="show_item item1">
          <div class="box" @click="goDetail(3)">
            <div class="icon">
              <i class="iconfont icon-jifen"></i>
            </div>
            <div class="name">荣誉资质</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="show_item item1">
          <div class="box" @click="goDetail(0)">
            <div class="icon">
              <i class="iconfont icon-comment"></i>
            </div>
            <div class="name">联系我们</div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <el-drawer
      title=""
      :visible.sync="drawer"
      :with-header="false"
      :append-to-body="true"
      direction="ltr"
    >
      <div>
        <el-menu
          :default-active="activeIndex"
          mode="vertical"
          @select="menuSelect"
          background-color="#1b1825"
          text-color="#fff"
          @open="handleOpen"
          active-text-color="#7b7981"
        >
          <template v-for="item in tabsList">
            <el-submenu
              :index="item.id.toString()"
              :key="item.id"
              :collapse="true"
            >
              <template slot="title">
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <template v-for="itm in item.children">
                  <router-link :key="itm.id" :to="itm.path" tag="div">
                    <el-menu-item :index="itm.id.toString()" :key="itm.id">{{
                      itm.name
                    }}</el-menu-item>
                  </router-link>
                </template>
              </el-menu-item-group>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hoverId: null,
      drawer: false,
      activeIndex: "",
      activeTab: "",
      tabsList: [
        {
          id: 1,
          name: "首页",
          path: "/home",
        },
        {
          id: 2,
          name: "产品中心",
          children: [
            { id: 21, name: "黄金糕" },
            { id: 22, name: "发展历程" },
            { id: 23, name: "荣誉资质" },
            { id: 23, name: "联系我们" },
          ],
        },
        {
          id: 3,
          name: "合作案例",
          path: "/cases",
        },
        {
          id: 4,
          name: "新闻动态",
          path: "/news",
        },
        {
          id: 5,
          name: "关于我们",
          children: [
            { id: 21, name: "企业简介", path: "/company" },
            { id: 22, name: "发展历程", path: "/home" },
            { id: 23, name: "荣誉资质", path: "/home" },
            { id: 23, name: "联系我们", path: "/home" },
          ],
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); //监听滚动事件
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/home" });
    },
    goDetail(num) {
      if (num == 0) {
        this.$router.push({ path: "/contact" });
      } else {
        let query = num == 1 ? "0" : num == 2 ? "1" : "2";
        this.$router.push({ path: "/company", query: { id: query } });
      }
    },
    menuSelect(index, indexPath) {
      console.log(index);
      console.log(indexPath);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    // tabs点击
    handleItem(item) {
      this.$router.push({ path: item.path });
    },
    mouseenter(item) {
      this.hoverId = item.id;
    },
    mouseleave() {
      this.hoverId = null;
    },
    // 滚动条
    handleScroll() {
      const top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; //兼容不同的浏览器
      if (top > 100) {
        this.$nextTick(() => {
          let Width = document.body.clientWidth;
          if (Width > 800) {
            this.$refs.fixHeard.style.position = "fixed";
            this.$refs.fixHeard.style.top = "0";
          } else {
            this.$refs.fixHeard.style.top = "4.375rem";
          }
        });
      } else {
        this.$nextTick(() => {
          this.$refs.fixHeard.style.position = "static";
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes wobble-hor-bottom {
  0%,
  100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: rotate(-9deg);
    transform: rotate(-9deg);
  }
  30% {
    -webkit-transform: rotate(9deg);
    transform: rotate(9deg);
  }
  45% {
    -webkit-transform: rotate(-5.6deg);
    transform: rotate(-5.6deg);
  }
  60% {
    -webkit-transform: rotate(3deg);
    transform: rotate(3deg);
  }
  75% {
    -webkit-transform: rotate(-1.2deg);
    transform: rotate(-1.2deg);
  }
}

// 大于800px
@media only screen and (min-width: 800px) {
  .navcontainer {
    padding: 0 80px;
    height: 100px;
    z-index: 91;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 4px 10px 2px rgba(127, 162, 187, 0.2);
    .icon {
      width: 200px;
      //   width: 18%;
      //   height: 52px;
      transform: scale(0.8);
      //   margin-right: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .Logo {
      display: flex;
      align-items: center;
    }
    .top_left {
      display: none;
    }
  }
  .tabs {
    display: flex;
    .item {
      width: 140px;
      height: 100px;
      display: flex;
      justify-content: center;
    }
  }
  .tabs_item {
    display: inline-flex;
    align-items: center;
    font-family: "Barlow", sans-serif;
    color: #7b7981;
    font-size: 18px;
    //   margin-left: 55px;
    cursor: pointer;
  }
  .tabs_item::before {
    opacity: 0;
    content: "";
    background-color: #42d9be;
    width: 10px;
    height: 2px;
    margin-right: 10px;
    transition: all 500ms ease;
  }
  .tabs_item:hover::before {
    opacity: 1;
  }
  .call {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon_calls {
      .iconfont {
        font-size: 30px;
        margin-right: 20px;
        color: #1989fb;
        transition: all 500ms ease;
      }
    }
    .text {
      p {
        width: 176px;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 28px;
      }
    }
  }
  /deep/.el-tabs {
    .el-tabs__nav-scroll {
      .el-tabs__active-bar {
        display: none;
      }
    }
    .el-tabs__nav-wrap::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      display: none;
      width: 100%;
      height: 2px;
      z-index: 1;
    }
  }
  .item_navcon {
    background: #ffffff;
    box-shadow: 0px 4px 10px 2px rgba(127, 162, 187, 0.2);
    position: fixed;
    left: 0;
    top: 100px;
    width: 100%;
    z-index: 11;
    transition: all 500ms ease;
    .show_box {
      background: #fff;
      max-width: 1200px;
      //   height: 180px;
      padding: 40px 0;
      margin: 0 auto;
      display: flex;
    }
    .show_item {
      width: calc(100% / 4);
      height: 100%;
      display: flex;
      align-items: start;
      justify-content: center;
      .icon {
        color: #1789fbff;
        .iconfont {
          font-size: 30px;
          //   transition: all 0.3s;
          &:hover {
            // animation: rock 0.5s ease-in-out infinite;
          }
        }
      }
      .text {
        margin-left: 20px;
        .title {
          font-size: 16px;
          //   font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #4a4a4a;
          display: inline-block;
          height: 30px;
          line-height: 30px;
          border-bottom: 1px solid #dcdcdc;
        }
        p {
          padding-top: 18px;
          font-size: 14px;
          //   font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4a4a4a;
          line-height: 20px;
          &:hover {
            color: #1789fb;
          }
        }
      }
    }
    .item1 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 50%;
        background: #f1f4f6ff;
        position: absolute;
        right: 0;
      }

      .icon {
        color: #1789fbff;
        &:hover {
          //   animation: rock 1s linear infinite;
          animation: wobble-hor-bottom 0.8s both;
          animation-delay: 1;
        }
        .iconfont {
          font-size: 50px;
        }
      }
      .name {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #4a4a4a;
        line-height: 22px;
        margin-top: 20px;
      }
    }
  }
  .fix_heard {
    min-width: 1400px;
    // position: fixed;
    // z-index: 991;
    // top: 0;
    // left: 0;
    background-color: #fff;
    width: 100%;
    //   visibility: hidden;
    // transform: translateY(-120%);
    //   transition: transform 500ms ease, visibility 500ms ease;
    transition: all 500ms ease;
    z-index: 99;
    // box-shadow: 0px 10px 60px 0px #0000000d;
  }
}
// 小于800px
@media only screen and (max-width: 800px) {
  .navcontainer {
    padding: 0 1rem;
    display: flex;
    .icon {
      width: 12rem;
      height: 4rem;
      transform: scale(0.8);
      //   margin-right: 2.8rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .Logo {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .tabs {
    display: none;
  }
  .call {
    display: none;
  }
  .top_left {
    height: 4rem;
    line-height: 4rem;
    .iconfont {
      font-size: 1rem;
      color: #1989fb;
    }
    &:hover {
      color: #000;
    }
  }
}
/deep/.el-drawer__wrapper {
  .el-drawer {
    background: #1b1825 !important;
    width: 60% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/comcomponents/NavTop.vue